import { Component, OnInit, OnDestroy, ChangeDetectorRef, ElementRef } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { DropzoneService } from '@app/core/services/dropzone.service';
import { Subscription } from 'rxjs';
import { environment } from '@env/environment';

@Component({
  selector: 'formly-field-dropzone',
  template: `
    <div class="article-dropzone-section" [style.margin-top]="to.label ? '0px' : '20px'">
      <!-- Dropzone Drag & Drop Area -->
      <div class="dropzone-area-wrapper">
        <div class="dropzone-form" [saDropzone]="to.dropzoneOptions">
          <div class="dz-default dz-message custom-dz-message">
            <div class="cloud-icon-wrapper">
              <i class="fa fa-cloud-upload upload-cloud-icon"></i>
            </div>
            <div class="drag-drop-title">{{ to.placeholder }}</div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
    .article-dropzone-section {
      width: 100%;
      background: transparent;
      border: none;
    }
    .dropzone-area-wrapper {
      position: relative;
      width: 100%;
      box-sizing: border-box;
      border: 1px dashed #3a4756;
      border-radius: 6px;
      background-color: var(--input-bg-color, #2f2f2f);
      transition: border-color 0.2s ease, background-color 0.2s ease;
      cursor: pointer;
    }
    .dropzone-area-wrapper:hover {
      border-color: #55667a;
      background-color: var(--input-bg-color, #2f2f2f);
    }
    .dropzone-form {
      width: 100%;
      height: auto;
      padding: 10px 14px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .custom-dz-message,
    ::ng-deep .dropzone-form .custom-dz-message,
    ::ng-deep .dropzone-form.dz-started .custom-dz-message,
    ::ng-deep .dropzone.dz-started .dz-message.custom-dz-message {
      display: flex !important;
      flex-direction: column !important;
      align-items: center !important;
      justify-content: center !important;
      text-align: center !important;
      margin: 0 !important;
      width: 100% !important;
      user-select: none;
      cursor: pointer;
    }
    .cloud-icon-wrapper {
      margin-bottom: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .cloud-icon-wrapper .upload-cloud-icon {
      font-size: 26px;
      color: var(--font-primary, rgba(255, 255, 255, 0.6));
      opacity: 0.7;
      transition: transform 0.2s ease;
    }
    .dropzone-area-wrapper:hover .cloud-icon-wrapper .upload-cloud-icon {
      transform: translateY(-2px) scale(1.05);
      color: var(--theme-color, #8B9635);
      opacity: 1;
    }
    .upload-icon-wrapper {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: rgba(255, 255, 255, 0.05);
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 8px auto;
      transition: background-color 0.2s ease, transform 0.2s ease;
    }
    .dropzone-area-wrapper:hover .upload-icon-wrapper {
      background-color: rgba(255, 255, 255, 0.08);
      transform: translateY(-2px);
    }
    .upload-icon-wrapper svg {
      transition: stroke 0.2s ease;
    }
    .dropzone-area-wrapper:hover .upload-icon-wrapper svg path {
      stroke: #cbd5e1;
    }
    .drag-drop-title {
      color: #ffffff;
      font-size: 13px;
      font-weight: 600;
      line-height: 1.3;
      margin: 0;
      text-align: center;
    }
    .drag-drop-subtitle {
      color: #8b99a8;
      font-size: 12px;
      font-weight: 400;
      line-height: 1.4;
      margin: 0 0 8px 0;
      text-align: center;
    }
    .btn-browse-files {
      background-color: #1a202a;
      color: #ffffff;
      border: 1px solid #384656;
      border-radius: 4px;
      padding: 4px 14px;
      font-size: 12px;
      font-weight: 500;
      line-height: 1.4;
      cursor: pointer;
      outline: none;
      transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
    }
    .btn-browse-files:hover {
      background-color: #242c38;
      border-color: #4a5c70;
      color: #ffffff;
    }
    .selected-files-container {
      margin-top: 8px;
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
    }
    .selected-files-header {
      color: #ffffff;
      font-size: 12px;
      font-weight: 600;
      margin: 0 0 5px 0;
      text-align: left;
    }
    .selected-files-list {
      display: flex;
      flex-direction: column;
      gap: 5px;
      width: 100%;
      max-width: 100%;
      max-height: 85px;
      overflow-y: auto;
      overflow-x: hidden;
      box-sizing: border-box;
      padding-right: 2px;
      scrollbar-width: none;
      -ms-overflow-style: none;
    }
    .selected-files-list::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
    }
    .selected-file-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: var(--input-bg-color, #2f2f2f);
      border: 1px solid #28313e;
      border-radius: 4px;
      padding: 4px 10px;
      min-height: 28px;
      box-sizing: border-box;
      width: 100%;
      max-width: 100%;
      overflow: hidden;
      transition: border-color 0.15s ease, background-color 0.15s ease;
    }
    .selected-file-item:hover {
      border-color: #384556;
      background-color: var(--input-bg-color, #2f2f2f);
    }
    .selected-file-name-wrapper {
      flex: 1 1 auto;
      min-width: 0;
      max-width: calc(100% - 64px);
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
      box-sizing: border-box;
      scrollbar-width: none;
      -ms-overflow-style: none;
      padding-bottom: 1px;
    }
    .selected-file-name-wrapper::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
    }
    .selected-file-name {
      color: #ffffff;
      font-size: 12px;
      font-weight: 400;
      white-space: nowrap;
      display: inline-block;
      text-align: left;
    }
    .selected-file-actions {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      flex: 0 0 auto;
      margin-left: 8px;
    }
    .btn-action-selected-file {
      background: transparent;
      border: none;
      padding: 3px 6px;
      color: #7d8c9c;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      outline: none;
      border-radius: 3px;
      font-size: 13px;
      transition: color 0.15s ease, background-color 0.15s ease, transform 0.15s ease;
    }
    .btn-action-selected-file:hover {
      color: #ffffff;
      background-color: rgba(255, 255, 255, 0.08);
      transform: scale(1.15);
    }
    .btn-download-selected-file:hover {
      color: var(--theme-color, #8B9635);
    }
    .btn-remove-selected-file:hover {
      color: #d9534f;
    }
  `]
})
export class FormlyFieldDropzone extends FieldType implements OnInit, OnDestroy {
  uploadedFiles: any[] = [];
  private fileSubscription: Subscription;
  private uploadSubscription: Subscription;
  private pollTimer: any;

  constructor(
    private dropzoneService: DropzoneService,
    private cdRef: ChangeDetectorRef,
    private elRef: ElementRef
  ) {
    super();
  }

  ngOnInit() {
    this.fileSubscription = this.dropzoneService.sendFileName.subscribe((files: any) => {
      if (Array.isArray(files)) {
        this.uploadedFiles = files;
      } else {
        this.uploadedFiles = [];
      }
      this.formControl.setValue(this.uploadedFiles);
      this.formControl.markAsTouched();
      this.formControl.updateValueAndValidity();
      this.cdRef.markForCheck();
      setTimeout(() => {
        this.repositionDialog();
      }, 50);
    });

    // Handle clear event
    this.uploadSubscription = this.dropzoneService.uploadFiles.subscribe((action: any) => {
      if (action === 'clear' || action === 'clearpdf') {
        this.uploadedFiles = [];
        this.formControl.setValue([]);
        this.formControl.markAsTouched();
        this.formControl.updateValueAndValidity();
        this.cdRef.markForCheck();
      }
    });

    this.pollForDropzone();
  }

  private pollForDropzone() {
    let attempts = 0;
    const check = () => {
      attempts++;
      const host = this.elRef.nativeElement;
      const dzElement = (host ? host.querySelector('.dropzone-form') : null) || (document.querySelector('.article-dropzone-section .dropzone-form') as any);
      if (dzElement && (dzElement as any).dropzone) {
        const dropzone = (dzElement as any).dropzone;
        if (dropzone.files && dropzone.files.length > 0 && (!this.uploadedFiles || this.uploadedFiles.length === 0)) {
          this.uploadedFiles = [...dropzone.files];
          this.formControl.setValue(this.uploadedFiles);
          this.cdRef.markForCheck();
        }
        dropzone.on('addedfile', () => {
          setTimeout(() => {
            this.uploadedFiles = [...(dropzone.files || [])];
            this.formControl.setValue(this.uploadedFiles);
            this.formControl.markAsTouched();
            this.formControl.updateValueAndValidity();
            this.cdRef.markForCheck();
            this.repositionDialog();
          }, 0);
        });
        dropzone.on('removedfile', () => {
          setTimeout(() => {
            this.uploadedFiles = [...(dropzone.files || [])];
            this.formControl.setValue(this.uploadedFiles);
            this.formControl.markAsTouched();
            this.formControl.updateValueAndValidity();
            this.cdRef.markForCheck();
            this.repositionDialog();
          }, 0);
        });
      } else if (attempts < 30) {
        this.pollTimer = setTimeout(check, 100);
      }
    };
    this.pollTimer = setTimeout(check, 100);
  }

  ngOnDestroy() {
    if (this.fileSubscription) {
      this.fileSubscription.unsubscribe();
    }
    if (this.uploadSubscription) {
      this.uploadSubscription.unsubscribe();
    }
    if (this.pollTimer) {
      clearTimeout(this.pollTimer);
    }
    const host = this.elRef.nativeElement;
    if (host) {
      const wrappers = host.querySelectorAll('.selected-file-name-wrapper');
      wrappers.forEach((w: any) => this.stopAutoScroll(w));
    }
  }

  onFileItemMouseEnter(event: MouseEvent) {
    const item = event.currentTarget as HTMLElement;
    if (!item) return;
    const wrapper = item.querySelector('.selected-file-name-wrapper') as HTMLElement;
    if (wrapper) {
      this.startAutoScroll(wrapper);
    }
  }

  onFileItemMouseLeave(event: MouseEvent) {
    const item = event.currentTarget as HTMLElement;
    if (!item) return;
    const wrapper = item.querySelector('.selected-file-name-wrapper') as HTMLElement;
    if (wrapper) {
      this.stopAutoScroll(wrapper);
    }
  }

  private startAutoScroll(el: HTMLElement) {
    if (!el || el.scrollWidth <= el.clientWidth) return;
    this.stopAutoScroll(el);

    const maxScroll = el.scrollWidth - el.clientWidth;
    let direction = 1;
    let pauseUntil = Date.now() + 350;
    (el as any)._isAutoScrolling = true;

    const animate = () => {
      if (!(el as any)._isAutoScrolling) return;
      const now = Date.now();
      if (now >= pauseUntil) {
        if (direction === 1) {
          el.scrollLeft += 1;
          if (el.scrollLeft >= maxScroll) {
            direction = -1;
            pauseUntil = now + 1200;
          }
        } else {
          el.scrollLeft -= 1.5;
          if (el.scrollLeft <= 0) {
            direction = 1;
            pauseUntil = now + 800;
          }
        }
      }
      (el as any)._animFrameId = requestAnimationFrame(animate);
    };

    (el as any)._animFrameId = requestAnimationFrame(animate);
  }

  private stopAutoScroll(el: HTMLElement) {
    if (!el) return;
    (el as any)._isAutoScrolling = false;
    if ((el as any)._animFrameId) {
      cancelAnimationFrame((el as any)._animFrameId);
      (el as any)._animFrameId = null;
    }
    el.scrollTo({ left: 0, behavior: 'smooth' });
  }

  browseFiles(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    const host = this.elRef.nativeElement;
    const dzElement = (host ? host.querySelector('.dropzone-form') : null) || (document.querySelector('.article-dropzone-section .dropzone-form') as any);
    if (dzElement && (dzElement as any).dropzone && (dzElement as any).dropzone.hiddenFileInput) {
      (dzElement as any).dropzone.hiddenFileInput.click();
    } else if (dzElement) {
      (dzElement as HTMLElement).click();
    }
  }

  formatSize(bytes: any): string {
    const num = Number(bytes);
    if (!num || isNaN(num) || num <= 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((num / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  getFileTooltip(file: any): string {
    const name = this.getFileName(file);
    if (!file) return name;
    const size = file.size ? this.formatSize(file.size) : '';
    return size ? `${name} (${size})` : name;
  }

  removeFile(file: any, index: number) {
    const host = this.elRef.nativeElement;
    const dzElement = (host ? host.querySelector('.dropzone-form') : null) || (document.querySelector('.article-dropzone-section .dropzone-form') as any);
    if (dzElement && (dzElement as any).dropzone) {
      const dropzone = (dzElement as any).dropzone;
      if (file && dropzone.files && dropzone.files.indexOf(file) !== -1) {
        dropzone.removeFile(file);
      } else if (dropzone.files && dropzone.files[index]) {
        dropzone.removeFile(dropzone.files[index]);
      }
      this.uploadedFiles = [...(dropzone.files || [])];
    } else {
      if (this.uploadedFiles && this.uploadedFiles[index]) {
        this.uploadedFiles.splice(index, 1);
        this.uploadedFiles = [...this.uploadedFiles];
      }
    }
    this.formControl.setValue(this.uploadedFiles);
    this.formControl.markAsTouched();
    this.formControl.updateValueAndValidity();
    this.cdRef.markForCheck();
    this.repositionDialog();
  }

  get existingFiles(): any[] {
    if (this.to && Array.isArray(this.to.existingFiles)) {
      return this.to.existingFiles;
    }
    if (this.model && Array.isArray(this.model.existingFiles)) {
      return this.model.existingFiles;
    }
    return [];
  }

  getFileName(file: any): string {
    if (!file) return '';
    if (typeof file === 'string') {
      return file.split('/').pop() || file;
    }
    const name = file.fileName || file.name || file.originalname || file.filename;
    if (name) return name;
    const filePath = file.filePath || file.filepath || file.fullFilePath || file.viewfilepath;
    if (filePath) {
      return filePath.split('/').pop() || filePath;
    }
    return '';
  }

  downloadExistingFile(file: any) {
    if (this.to && typeof this.to.onDownloadExistingFile === 'function') {
      this.to.onDownloadExistingFile(file);
      return;
    }
    const path = file.fullFilePath || file.filePath || file.downloadpath || '';
    if (!path) return;
    const url = (path.startsWith('http://') || path.startsWith('https://'))
      ? path
      : environment.NETGATE_URL + path;
    const fileName = this.getFileName(file) || 'download';

    fetch(url)
      .then(res => {
        if (!res.ok) throw new Error('Fetch failed');
        return res.blob();
      })
      .then(blob => {
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(blobUrl);
      })
      .catch(() => {
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        link.setAttribute('target', '_blank');
        document.body.appendChild(link);
        link.click();
        link.remove();
      });
  }

  removeExistingFile(file: any, index: number) {
    if (this.to && Array.isArray(this.to.existingFiles) && this.to.existingFiles.length > index) {
      this.to.existingFiles.splice(index, 1);
    }
    if (this.model && Array.isArray(this.model.existingFiles) && this.model.existingFiles !== this.to?.existingFiles) {
      const modelIdx = this.model.existingFiles.indexOf(file);
      if (modelIdx !== -1) {
        this.model.existingFiles.splice(modelIdx, 1);
      } else if (this.model.existingFiles.length > index) {
        this.model.existingFiles.splice(index, 1);
      }
    }
    if (this.to && typeof this.to.onRemoveExistingFile === 'function') {
      this.to.onRemoveExistingFile(file, index);
    }
    this.cdRef.markForCheck();
    this.repositionDialog();
  }

  removeFileAtIndex(index: number) {
    this.removeFile(this.uploadedFiles ? this.uploadedFiles[index] : null, index);
  }

  private repositionDialog() {
    try {
      const $ = (window as any).$;
      if ($) {
        const $dialog = $('.cart-generate-article-dialog #generatearticle');
        if ($dialog.length && $dialog.hasClass('ui-dialog-content') && $dialog.dialog('isOpen')) {
          $dialog.dialog('option', 'position', { my: 'center', at: 'center', of: window });
        }
      }
    } catch (e) { }
  }
}
